import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HouseSidingIcon(props: IconProps) {
    return <Icon {...props} iconKey={"house_siding"}/>
}
